import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import LazyLoad from "../../Lazyload";
import Loadable from "../../Loadable";
import MentorsSkeleton from "./components/MentorsSkeleton";
import { jsx as _jsx } from "react/jsx-runtime";
var LazyMentors = function LazyMentors(props) {
  return /*#__PURE__*/_jsx(LazyLoad, {
    placeholder: /*#__PURE__*/_jsx("div", {
      className: "w-full",
      style: {
        minHeight: 576
      }
    }),
    children: /*#__PURE__*/_jsx(Loadable, _objectSpread({
      Loader: /*#__PURE__*/_jsx(MentorsSkeleton, {
        isDark: props.isDark
      }),
      module: function module() {
        return import(/* webpackChunkName: "home-mentors" */"./Mentors");
      }
    }, props))
  });
};
export default LazyMentors;